<div class="spinner" *ngIf="showSpinner">
    <div class="spinner-inner"></div>
</div>

<div *ngIf="!showSpinner && (!length || length == 0) && showNotFound" class="text-muted text-center p-3">
    <i class="fa fa-exclamation-circle me-1"></i> Kayıt Bulunamadı.
</div>